import { getRtbDateString } from './timezones';

const DAY_MS = 24 * 60 * 60 * 1000;

const kzToday = () => {
    const [year, month, day] = getRtbDateString().split('-').map(Number);
    return new Date(year, month - 1, day);
};

/** YYYY-MM-DD по компонентам даты. Для пресетов день уже взят в поясе RTB. */
export const toDateInputValue = (date) => {
    const pad = value => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

const parseDateInput = value => (value ? new Date(`${value}T00:00:00`) : null);

/** Число дней в периоде включительно; null, если дата не задана. */
export const periodLengthDays = (startValue, endValue) => {
    const start = parseDateInput(startValue);
    const end = parseDateInput(endValue);
    if (!start || !end) return null;
    return Math.round((end - start) / DAY_MS) + 1;
};

const quarterStartMonth = month => Math.floor(month / 3) * 3;

/** Готовые периоды: «текущие» заканчиваются сегодня, «прошлые» — полные. */
export const PERIOD_PRESETS = Object.freeze([
    {
        id: 'current-month',
        label: 'Этот месяц',
        range: today => [new Date(today.getFullYear(), today.getMonth(), 1), today],
    },
    {
        id: 'previous-month',
        label: 'Прошлый месяц',
        range: today => [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
    },
    {
        id: 'current-quarter',
        label: 'Этот квартал',
        range: today => [new Date(today.getFullYear(), quarterStartMonth(today.getMonth()), 1), today],
    },
    {
        id: 'previous-quarter',
        label: 'Прошлый квартал',
        range: (today) => {
            const start = quarterStartMonth(today.getMonth());
            return [new Date(today.getFullYear(), start - 3, 1), new Date(today.getFullYear(), start, 0)];
        },
    },
]);

/** [start, end] пресета в формате input[type=date]. */
export const presetRange = (preset, today = kzToday()) => preset.range(today).map(toDateInputValue);
